import { RouteObject, Navigate } from 'react-router-dom';

export const crmRoutes: RouteObject[] = [
  {
    path: '',
    element: <Navigate to="/sales/essentials/deals-pipeline" replace />,
  },
  {
    path: 'deals',
    element: <Navigate to="/sales/essentials/deals-pipeline" replace />,
    handle: { crumb: 'Pipeline & Deals' },
  },
  {
    path: 'contacts',
    element: <Navigate to="/sales/essentials/leads" replace />,
    handle: { crumb: 'Contacts & Leads' },
  },
  {
    path: 'companies',
    element: <Navigate to="/core/directory/companies" replace />,
    handle: { crumb: 'Companies' },
  },
];
